import { ChatDetailsPanelContent } from "@/components/internal-chats/chat-details-panel";
import {
  useInternalOpsChannel,
  useInternalOpsChannels,
} from "@/lib/api/internal-ops-messaging";
import useSendbirdStateContext from "@sendbird/uikit-react/useSendbirdStateContext";
import { useMemo } from "react";

interface SupportDetailsSidebarProps {
  channelUrl: string;
  internalChannelId: string | null;
}

export function SupportDetailsSidebar({
  channelUrl,
  internalChannelId,
}: SupportDetailsSidebarProps) {
  const store = useSendbirdStateContext();
  const { data: channels } = useInternalOpsChannels(true);
  const resolvedChannelId = useMemo(
    () =>
      internalChannelId ??
      channels?.find((channel) => channel.sdk_url === channelUrl)?.id ??
      null,
    [channelUrl, channels, internalChannelId],
  );
  const { data: internalChannel } =
    useInternalOpsChannel(resolvedChannelId);

  return (
    <ChatDetailsPanelContent
      internalChannel={internalChannel ?? null}
      currentUserId={store.config.userId}
      appearance="workflow"
    />
  );
}
